import React from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import {useHistory} from "react-router-dom";
import {useSearch} from "./context/SearchContext"; // For React Router v5

const SearchComponent = () => {
    const {query, setQuery} = useSearch(); // Access query and setQuery from context
    const history = useHistory();

    // Function to handle form submission

    return (
        <SearchComponentStyle className={'form-area d-lg-block d-md-block d-sm-none'}>
            <Form>
                <Form.Group controlId="formBasicEmail">
                    <Form.Control
                        className={'border-top-0 border-left-0 border-right-0'}
                        type="text"
                        placeholder="Search"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)} // Update query in context
                    />
                </Form.Group>
            </Form>

            <div className="search-icon" >
                <img src="/images/static/search.svg" alt="search icon"/>
            </div>
        </SearchComponentStyle>
    );
};

const SearchComponentStyle = styled.div`
    position: relative;

    .search-icon {
        position: absolute;
        content: '';
        bottom: 5px;
        left: 0;
    }

    input {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.5);
        background-color: transparent;

        padding-left: 30px;

        &::placeholder {
            color: rgba(0, 0, 0, 0.5);
        }

        &:focus {
            border-bottom: 1px solid rgb(127, 127, 127);
        }
    }

    /* small mobile :320px. */
    @media (max-width: 767px) {
        display: none;
        .mb-3 {
            margin-bottom: unset !important;
        }
    }
`;

export default SearchComponent;
